import React, { useState } from "react"
import './Radio.css'

interface Props
{
	title?: string
	checked?: boolean
	onChange?: () => void
}

const Radio = (props: Props) =>
{
	let [state, setState] = useState(props.checked)

	if (props.checked != state)
	{
		setState(props.checked)
	}

	return (
		<div className="d-flex flex-column align-items-center radio-container">
			<div onClick={() => { setState(!state); props.onChange?.call(props); }} className="radio" >
				<div className="radio-content" style={{ display: state ? "block" : "none" }} />
			</div>
			<div>{props.title}</div>
		</div>
	)
}

export default Radio
